<template>
  <v-card flat tile :loading='loading' :class='backgroundClass'>
    <v-container :class="fullWidth ? 'wide-container' : ''">
      <v-row no-gutters align='center'>
        <v-col>
          <span :class='titleClass'>
            {{ title }}
          </span>
          <br v-if="$vuetify.breakpoint.smAndDown || subtitleBreak">
          <span :class='subtitleClass'>{{ subtitle }}</span>
          <slot align='start' name='appendSubtitle'></slot>
          <v-btn v-if='hasBtn' :to='btnRoute' class='mb-2' outlined color='primary lighten-2'>
            <v-icon left>{{ btnIcon }}</v-icon>
            {{ btnText }}
          </v-btn>
        </v-col>
        <v-col class='text-right' align-self='start' cols='auto'>
          <slot name='rightSide'></slot>
          <v-btn
            v-if='showAdd'
            icon
            small
            @click="$emit('add')"
          >
            <v-icon color='grey lighten-2'>mdi-plus</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: 'page-title',
  props: {
    title: String,
    subtitle: String,
    btnRoute: Object,
    btnText: String,
    btnIcon: String,
    hasBtn: Boolean,
    showAdd: {
      required: false,
      type: Boolean,
      default: false
    },
    fullWidth: {
      required: false,
      type: Boolean,
      default: false
    },
    loading: {
      required: false,
      type: Boolean,
      default: false
    },
    subtitleBreak: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    backgroundClass: 'mt-0'
    // backgroundClass: 'grey lighten-4'
  }),
  computed: {
    titleClass () {
      if (this.$vuetify.breakpoint.xs) {
        return 'headline info--text font-weight-light text-uppercase'
      }
      return 'display-1 info--text font-weight-light text-uppercase'
    },
    subtitleClass () {
      if (this.$vuetify.breakpoint.xs) {
        return 'title grey--text font-weight-light'
      }
      return 'headline grey--text font-weight-light'
    }
  },
  methods: {
    toggleDrawer () {
      if (this.$store.getters.getDrawerStatus) {
        this.$store.dispatch('closeDrawer')
      } else {
        this.$store.dispatch('openDrawer')
      }
    }
  }
}
</script>

<style scoped>
.wide-container {
  /* max-width: 100% !important; */
  max-width: 1830px !important;
  margin-left: 0px !important;
  padding-left: 16px !important;
}
</style>
